module.exports = __webpack_public_path__ + "static/logo-3390cc3b9fc624324311f6acc16c7c9d.png";